import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSortable } from "utils/sortable/src";
import { CSS } from "@dnd-kit/utilities";
import { TwitterPicker } from "react-color";
import { toggleGroup } from "actions/groups";
import { isChromeExtension, isPopupExtension } from "utils/extension";
import messages from "utils/messages";
import GroupControlPanel from "components/GroupControlPanel/GroupControlPanel";
import { color2hex, hex2color } from "utils/colors";
import { editGroup } from "actions/groups";
import { showModal } from "actions/modal";
import moment from "moment";

export default function MenuItem({ id }) {
  const group = useSelector((state) => state.groupsEntities[id] || {});
  const span = useRef();
  const container = useRef();
  const dispatch = useDispatch();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    overCollapsedGroupId,
    setActivatorNodeRef,
    isDragging,
    isDraggingHabit,
  } = useSortable({ id, data: group });

  // if (id === 1) console.log("menuitem", transform);

  const borderColor = color2hex(group.color);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.75 : 1,
    position: isDragging ? "relative" : undefined,
    zIndex: isDragging ? 10000 : 1,
  };
  const isDroppable = overCollapsedGroupId === id;

  function handleColorChange(color) {
    const newGroup = { ...group, color: hex2color(color.hex) };
    dispatch(editGroup(newGroup));
  }

  function handleTimeChange(time) {
    const newTime = time && moment(time, "HH:mm").isValid() ? time : null;

    const newGroup = { ...group, time: newTime };
    dispatch(editGroup(newGroup));
  }

  function showEditModal() {
    dispatch(showModal("editGroup", { title: messages.EDIT_GROUP, group }));
  }

  function handleClick() {
    if (group.numHabits > 0) dispatch(toggleGroup(group.id));
  }

  const html = (
    <li
      ref={setNodeRef}
      style={style}
      key={id}
      className={
        "menuItemLI " +
        (!isChromeExtension() && "not-extension ") +
        (isDroppable && "droppable")
      }
    >
      <GroupControlPanel
        group={group}
        attributes={attributes}
        listeners={listeners}
        setActivatorNodeRef={setActivatorNodeRef}
        onEditClick={showEditModal}
        onColorChange={handleColorChange}
        isDragging={isDragging}
        isDroppable={isDroppable}
        isDraggingHabit={isDraggingHabit}
        onTimeChange={handleTimeChange}
        // color={color}
      />
      <a
        style={{
          borderColor,
          borderLeftWidth: 5,
          borderLeftStyle: "solid",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
        className="draggable group-name"
        onClick={handleClick}
      >
        <div
          style={{
            lineHeight: "16px",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          }}
          ref={span}
        >
          {group.name?.toUpperCase()}
        </div>
      </a>
    </li>
  );

  return html;
}
